import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export const getCookieValue = (
  request: Request,
  cookieName: string
): string | null => {
  const cookieHeader = request.headers.get("Cookie")
  const match = cookieHeader?.match(
    new RegExp(`(^|;\\s*)${cookieName}=([^;]*)`)
  )
  return match ? decodeURIComponent(match[2]) : null
}
